module.exports = __webpack_public_path__ + "img/wgl.png";